module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.5f2071a.eot";